var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.skinClasses],staticStyle:{"height":"100vh"},attrs:{"id":"app"}},[_c('router-view'),_c('GlobalComponents'),_c('BannerCookies'),_c('NexosNotificationModal'),_c('GDPRModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }